import { ReactComponent } from '../../../../Utils/Types';
import { ScrollView } from '../ScrollView/ScrollView';
import { SidebarBetaSection } from './Sections/SidebarBetaSection';
import { SidebarFavoriteMoonListSection } from './Sections/SidebarFavoriteMoonListSection';
import { SidebarHeaderSection } from './Sections/SidebarHeaderSection';
import { SidebarMoonListSection } from './Sections/SidebarMoonListSection';
import { SidebarNavigationSection } from './Sections/SidebarNavigationSection';

export function Sidebar(): ReactComponent {
  return (
    <div className="sticky top-0 flex" style={{ width: '380px' }}>
      <div className="sticky top-0 w-full h-screen v-stack bg-sidebar-bg">
        <ScrollView className="p-4 grow">
          <SidebarHeaderSection />
          <SidebarNavigationSection />
          <SidebarBetaSection />
          <SidebarFavoriteMoonListSection />
          <SidebarMoonListSection />
        </ScrollView>
        <div className="p-4 text-xs text-opacity-30 text-tint">
          Made with ❤️ by{' '}
          <a className="underline cursor-pointer hover:opacity-70" href="https://github.com/bpisano">
            bpisano
          </a>
        </div>
      </div>
      <div className="sticky top-0 w-px h-screen bg-tint opacity-10"></div>
    </div>
  );
}
